import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
const tabRoutes = {
  Home: "/home",
  Services: "/all-features",
  "AI Assist": "/asha-cover",
  Wallet: "/health-wallet",
  Profile: "/profile",
};

const TABS = [
  {
    name: "Home",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
        <path
          clipRule="evenodd"
          fillRule="evenodd"
          d="m13.8186 4.6664c-1.0747-.88853-2.5625-.88853-3.6371 0l-5.38611 4.45324c-.49114.40608-.79539 1.04766-.79539 1.74666v6.9446c0 1.2675.95214 2.1891 2 2.1891h2v-3.2522c0-2.2551 1.73415-4.1891 4-4.1891 2.2659 0 4 1.934 4 4.1891v3.2522h2c1.0479 0 2-.9216 2-2.1891v-6.9446c0-.699-.3042-1.34058-.7954-1.74665zm1.2744-1.54138 5.386 4.45325c.9704.80232 1.521 2.01878 1.521 3.28803v6.9446c0 2.2551-1.7341 4.1891-4 4.1891h-2c-1.1046 0-2-.8954-2-2v-3.2522c0-1.2675-.9521-2.1891-2-2.1891s-2 .9216-2 2.1891v3.2522c0 1.1046-.89543 2-2 2h-2c-2.26585 0-4-1.934-4-4.1891v-6.9446c0-1.26925.55059-2.48571 1.52097-3.28803l5.38606-4.45325c1.81427-1.50003 4.37167-1.50003 6.18597 0z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Services",
    icon: (
      <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
  },
  {
    name: "AI Assist",
    icon: (
      <svg viewBox="0 0 512 512" width="20" height="20" fill="currentColor">
        <path d="m256 16c-10.7 220.5-19.5 229.3-240 240 220.5 10.7 229.3 19.5 240 240 10.7-220.5 19.5-229.3 240-240-220.5-10.7-229.3-19.5-240-240z" />
      </svg>
    ),
    isCenter: true,
  },
  {
    name: "Wallet",
    icon: (
      <svg viewBox="0 0 512.076 512.076" width="19" height="19" fill="currentColor">
        <path d="m492.039 141.076c11.046 0 20-8.954 20-20v-21c0-55.182-44.895-100.076-100.077-100.076 0 0-313.508.047-314.281.138-26.389.922-51.738 12.246-70.01 31.392-18.729 19.624-28.493 45.148-27.574 72.003-.038.509-.058 288.467-.058 288.467 0 66.21 53.866 120.076 120.076 120.076h291.848c55.182 0 100.076-44.894 100.076-100.076v-151.848c0-55.182-44.894-100.076-100.076-100.076h-311.925c-32.111 0-58.437-25.098-59.934-57.138-.761-16.292 5.1-31.844 16.502-43.792 11.567-12.12 27.812-19.07 44.568-19.07.591 0 310.787-.076 310.787-.076 33.126 0 60.076 26.95 60.076 60.076v21c.002 11.046 8.956 20 20.002 20zm-392.001 59h311.924c33.126 0 60.076 26.95 60.076 60.076v151.848c0 33.126-26.95 60.076-60.076 60.076h-291.847c-44.154 0-80.076-35.922-80.076-80.076v-211.843c16.728 12.53 37.513 19.919 59.999 19.919zm332.001 136c0 13.807-11.193 25-25 25-33.162-1.317-33.153-48.688 0-50 13.807 0 25 11.193 25 25zm0-236c0-11.046-8.954-20-20-20h-312c-26.536 1.056-26.516 38.953 0 40h312c11.045 0 20-8.954 20-20z" />
      </svg>
    ),
  },
  {
    name: "Profile",
    icon: (
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-3.5 3.5-6 8-6s8 2.5 8 6" />
      </svg>
    ),
  },
];

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
   <motion.div
  initial={{
    y: 80,
    opacity: 0,
  }}
  animate={{
    y: 0,
    opacity: 1,
  }}
  transition={{
    duration: 0.5,
    type: "spring",
  }}
  style={{
    maxWidth: 420,
    margin: "0 auto",
    position: "fixed",
    left: "10%",
    width: "80%",
    bottom: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  }}
>
      {TABS.map((tab) => {
        const isActive = location.pathname === tabRoutes[tab.name];

        return (
          <motion.button
  key={tab.name}
  layout
  whileTap={{ scale: 0.92 }}
  className = "glass"
  animate={{
    scale: isActive ? 1.05 : 1,
  }}
  transition={{
    layout: {
      duration: 0.35,
      type: "spring",
      stiffness: 450,
      damping: 30,
    },
    scale: {
      duration: 0.2,
    },
  }}
  onClick={() => navigate(tabRoutes[tab.name])}
  aria-label={tab.name}
style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: isActive ? 7 : 0,
  height: 44,
  minWidth: 44,
  padding: isActive ? "0 16px 0 8px" : "0",
  borderRadius: 999,


 background: isActive ? "var(--primary)" : "#e8e0ff",

backdropFilter: "blur(20px) saturate(180%)",
WebkitBackdropFilter: "blur(20px) saturate(180%)",

border: isActive
  ? "none"
  : "1px solid rgba(255,255,255,.35)",

color: isActive ? "#fff" : "#111",

boxShadow: isActive
  ? "0 8px 20px rgba(127,0,255,.35)"
  : `
      0 8px 24px rgba(0,0,0,.12),
      inset 0 1px 1px rgba(255,255,255,.45)
    `,
  flexShrink: 0,
}}
>
          <motion.span
  layout
  animate={{
    rotate: isActive ? [0, -10, 8, 0] : 0,
    scale: isActive ? 1.12 : 1,
  }}
  transition={{
    duration: 0.45,
    ease: "easeOut",
  }}
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 26,
    height: 26,
    borderRadius: "50%",
    flexShrink: 0,
   background: isActive
  ? "#eeefef"
  : "rgba(255,255,255,.45)",

backdropFilter: "blur(12px)",
WebkitBackdropFilter: "blur(12px)",

border: isActive
  ? "none"
  : "1px solid rgba(255,255,255,.5)",

color: isActive
  ? "var(--primary)"
  : "#111",
  }}
>
  {tab.icon}
</motion.span>

            <AnimatePresence mode="wait">
  {isActive && (
    <motion.span
      initial={{
        opacity: 0,
        x: -10,
        width: 0,
      }}
      animate={{
        opacity: 1,
        x: 0,
        width: "auto",
      }}
      exit={{
        opacity: 0,
        x: -10,
        width: 0,
      }}
      transition={{
        duration: 0.25,
      }}
      style={{
        fontSize: 13,
        fontWeight: 600,
        color: "#fff",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      {tab.name}
    </motion.span>
  )}
</AnimatePresence>
          </motion.button>
        );
      })}
    </motion.div>
  );
}